import http from '@/http'

const SET_LOADING = 'SET_LOADING'
const RESET_LOADING = 'RESET_LOADING'
const SET_ALERT = 'SET_ALERT'
const RESET_ALERT = 'RESET_ALERT'
const defaultError = 'Não foi possível completar a requisição'

export const state = {
  loading: false,
  alert: null
}

export const mutations = {
  [SET_LOADING] (state) {
    state.loading = true
  },
  [RESET_LOADING] (state) {
    state.loading = false
  },
  [SET_ALERT] (state, payload) {
    state.alert = payload
  },
  [RESET_ALERT] (state) {
    state.alert = null
  }
}

export const actions = {
  /**
   * Get company by id.
   * @function
   * @param {string} id - Context Company ID
   */
  getCompanies ({ commit }, id) {
    commit(SET_LOADING)

    return http.get(`/api/companies/?id=${id}`).then(response => {
      if (response.status === 200) {
        commit(RESET_LOADING)
        return Promise.resolve(response.data.results[0])
      }
      commit(RESET_LOADING)
    }).catch(() => {
      /* TODO HANDLE ERROR */
      commit(RESET_LOADING)
    })
  },

  /**
   * Update company
   * @function
   * @param {object} data - Form data
   */
  patchCompany ({ commit }, data) {
    commit(SET_LOADING)
    commit(RESET_ALERT)

    return http.patch('/api/companies/', data).then(response => {
      if (response.status === 200) {
        commit(RESET_LOADING)
        commit(SET_ALERT, 'Cadastro empresarial atualizado com sucesso.')
      } else {
        commit(RESET_LOADING)
        commit(SET_ALERT, response.data.message)
      }
      return Promise.resolve(response)
    }).catch(error => {
      /* TODO HANDLE ERROR */
      commit(SET_ALERT, error.response.data.message)
      commit(RESET_LOADING)
      return Promise.reject(error)
    })
  },

  /**
   *
   *
   *
   * Admin
   */

  /**
   * Get admin companies by query params
   * @function
   * @param {object} search, page, ordering - Query String Params
   * ?term=name|cnpj|nome_fantasia&ordering=name|-name|fantasy_name|-fantasy_name|creation_date|-creation_date&page=1
   */
  getAdminCompanies ({ commit }, { search, page, ordering }) {
    const term = (search) ? `?term=${search}` : '?'
    const currentPage = (page) ? `&page=${page}` : ''
    const orderBy = (ordering) ? `&ordering=${ordering}` : ''
    commit(SET_LOADING)

    return http.get(`/api/admin/companies${term}${currentPage}${orderBy}`).then(response => {
      if (response.status === 200) {
        commit(RESET_LOADING)
        return Promise.resolve(response.data)
      }
      commit(RESET_LOADING)
      return Promise.reject(response)
    }).catch(error => {
      commit(RESET_LOADING)
      const message = (error.response.data.message) ? error.response.data.message : defaultError
      return Promise.reject(message)
    })
  },

  /**
   * Get admin company by document number
   * @function
   * @param {string} documentNumber - Company CNPJ
   */
  getAdminCompany ({ commit }, documentNumber) {
    commit(SET_LOADING)

    return http.get(`/api/admin/company/${documentNumber}`).then(response => {
      if (response.status === 200) {
        commit(RESET_LOADING)
        return Promise.resolve(response.data)
      }
      commit(RESET_LOADING)
    }).catch(error => {
      commit(RESET_LOADING)
      const message = (error.response.data.message) ? error.response.data.message : defaultError
      return Promise.reject(message)
    })
  },

  /**
   * Post admin document number
   * @function
   * @param {number} document_number - Company CNPJ
   */
  postAdminCompany ({ commit }, documentNumber) {
    commit(SET_LOADING)

    return http.post('/api/admin/company', { document_number: documentNumber })
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data)
        }
        commit(RESET_LOADING)
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

  /**
   * Update admin company
   * @function
   * @param {object} data - Form data
   */
  postAdminCompanyUpdate ({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/update', { ...data }).then(response => {
      if (response.status === 200) {
        commit(RESET_LOADING)
        return Promise.resolve(response.data.message)
      }
    }).catch(error => {
      commit(RESET_LOADING)
      const message = (error.response.data.message) ? error.response.data.message : defaultError
      return Promise.reject(message)
    })
  },

  /**
   * Post image
   * @function
   * @param {object} data - Form data
   */
  postAdminCompanyUpdateLogo ({ commit }, formData) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/update/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data.message)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

  /**
   * Post limit
   * @function
   * @param {object} data - Form data
   */
  postAdminCompanyUpdateLimit ({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/update/limit', data)
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data.message)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

    postAdminCompanyUpdateDailyLimitPerUser({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/update/daily_limit_per_employee', data)
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data.message)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

  /**
   * Post block company
   * @function
   * @param {object} id - company id
   */
  postAdminCompanyBlock ({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/block', data)
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data.message)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

  /**
   * Post partner company
   * @function
   * @param {object} id - company id
   */
  postAdminCompanyUpdateRepresentative ({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/update/representative', data)
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data.message)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

  /**
   * Post cashback
   * @function
   * @param {object} data - Form data
   */
  postAdminCompanyUpdateCashback ({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/admin/company/update/cashback', data)
      .then(response => {
        if (response.status === 200) {
          commit(RESET_LOADING)
          return Promise.resolve(response.data.message)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
  /* getters */
}
